import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownModule } from '../dropdown/dropdown.module';
import { SortableComponent } from './sortable-component/sortable.component';
import { SortableContainerDirective } from './sortable-container.directive';
import { SortableService } from './sortable.service';


@NgModule({
  imports: [CommonModule, DropdownModule],
  declarations: [
    SortableComponent,
    SortableContainerDirective,
  ],
  exports: [
    SortableComponent,
    SortableContainerDirective,
   ],
  providers: [SortableService]
})
export class SortableModule { }
